import { render, staticRenderFns } from "./MobileView.vue?vue&type=template&id=2fa6ef4f&scoped=true&"
import script from "./MobileView.vue?vue&type=script&lang=js&"
export * from "./MobileView.vue?vue&type=script&lang=js&"
import style0 from "./MobileView.vue?vue&type=style&index=0&id=2fa6ef4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa6ef4f",
  null
  
)

export default component.exports